var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraw1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.435,
    width: 50,
    height: 50,
    rx: 4,
    fill: "url(#draw1_svg__paint0_linear_1_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.325 37.858l1.259 1.253a1.114 1.114 0 001.57 0l5.679-5.654a.552.552 0 00.16-.448l-.19-1.846a.554.554 0 00-.496-.493l-1.854-.19a.557.557 0 00-.45.16l-5.678 5.654a1.103 1.103 0 000 1.564",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.64 15.083a.69.69 0 00.432-.878l-.792-2.302a.695.695 0 00-1.313.447l.791 2.303a.694.694 0 00.882.43zm-7.189 7.071a.69.69 0 00-.432-.878l-2.311-.788a.695.695 0 00-.882.43.69.69 0 00.432.878l2.312.788a.694.694 0 00.882-.43zM30.85 36.791a.692.692 0 01-.685.808.694.694 0 01-.684-.573l-.398-2.303a.695.695 0 011.368-.235l.399 2.303zm9.113-8.675a.69.69 0 00-.432-.878l-2.312-.788a.69.69 0 10-.45 1.308l2.313.788a.694.694 0 00.882-.43zm-3.632-11.93l-1.717 1.71a.694.694 0 01-.982-.978l1.717-1.71c.271-.27.71-.27.982 0a.689.689 0 010 .978z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.945 22.438L32.4 26.1l2.132 5.42a.554.554 0 01-.716.718L28.36 30.15l-3.648 4.549a.556.556 0 01-.982-.259l-.913-5.75-5.78-.87a.552.552 0 01-.266-.977l4.544-3.663-2.133-5.42a.554.554 0 01.717-.718l5.457 2.088 3.647-4.549a.556.556 0 01.983.26l.912 5.749 5.78.871a.552.552 0 01.267.977",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "draw1_svg__paint0_linear_1_2",
    x1: -25,
    y1: 25.435,
    x2: 25,
    y2: 75.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#F85691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585CFF"
  })))));
}
export default SvgDraw1;